<div class="card">
    <div class="flex align-items-center justify-content-between mb-2">
        <span class="font-medium">Filtros avançados</span>
        <button pButton type="button" label="Limpar filtros" icon="pi pi-filter-slash"
            class="p-button-outlined p-button-sm" [disabled]="isDisabled || !hasGroups" (click)="clearFilters()"></button>
    </div>

    <div class="flex align-items-center gap-2 mb-2 flex-wrap" *ngIf="groups.length > 1">
        <span class="text-500 text-sm">Combinar grupos com:</span>
        <p-selectButton class="ss-g-selectButton-50" [options]="groupCombinatorOptions" [(ngModel)]="topOperator"
            optionLabel="label" optionValue="value" [disabled]="isDisabled" (onChange)="onRuleChanged()"></p-selectButton>
    </div>

    <div class="flex flex-column gap-3">
        <div class="feed-filter-group" *ngFor="let group of groups; let gi = index">
            <!-- Cabeçalho do grupo (numeração + remover) só aparece com 2+
                 grupos, pra não mudar o visual do caso simples (1 grupo só). -->
            <div class="flex align-items-center justify-content-between mb-2" *ngIf="groups.length > 1">
                <span class="text-500 text-sm font-medium">Grupo {{ gi + 1 }}</span>
                <button pButton type="button" icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-danger flex-shrink-0" [disabled]="isDisabled"
                    (click)="removeGroup(gi)"></button>
            </div>

            <div class="flex align-items-center gap-2 mb-2 flex-wrap" *ngIf="group.rules.length > 1">
                <span class="text-500 text-sm">Combinar regras com:</span>
                <p-selectButton class="ss-g-selectButton-50" [options]="ruleCombinatorOptions" [(ngModel)]="group.operator"
                    optionLabel="label" optionValue="value" [disabled]="isDisabled"
                    (onChange)="onRuleChanged()"></p-selectButton>
            </div>

            <!-- Layout em flexbox (não grid col-*/md:col-*) de propósito: esse
                 componente sempre renderiza dentro da sidebar estreita de criação
                 de feed, independente da largura da janela do navegador — as
                 classes responsivas do PrimeFlex reagem ao viewport, não ao
                 container, então md:col-* aqui ficava aplicando a largura de
                 desktop (25% cada) dentro de uma sidebar de ~400px, espremendo
                 os dropdowns e empurrando a lixeira pra fora da própria coluna. -->
            <div class="flex flex-column gap-2">
                <div class="flex align-items-center gap-2 feed-filter-rule"
                    *ngFor="let rule of group.rules; let ri = index">
                    <p-dropdown [options]="fieldOptions" [(ngModel)]="rule.field" optionLabel="label"
                        optionValue="value" [appendTo]="'body'" styleClass="ss-feed-filter-field"
                        [disabled]="isDisabled" (onChange)="onRuleChanged()"></p-dropdown>
                    <p-dropdown [options]="operatorOptions" [(ngModel)]="rule.operator" optionLabel="label"
                        optionValue="value" [appendTo]="'body'" styleClass="ss-feed-filter-operator"
                        [disabled]="isDisabled" (onChange)="onRuleChanged()"></p-dropdown>
                    <input type="text" pInputText [(ngModel)]="rule.values[0]" (ngModelChange)="onRuleChanged()"
                        class="ss-feed-filter-values" placeholder="Digite um valor" [disabled]="isDisabled">
                    <button pButton type="button" icon="pi pi-trash"
                        class="p-button-text p-button-rounded p-button-danger flex-shrink-0" [disabled]="isDisabled"
                        (click)="removeRule(gi, ri)"></button>
                </div>
            </div>

            <div class="mt-2">
                <button pButton type="button" label="Adicionar regra" icon="pi pi-plus"
                    class="p-button-text p-button-sm" [disabled]="isDisabled" (click)="addRule(gi)"></button>
            </div>
        </div>
    </div>

    <div class="mt-2">
        <button pButton type="button" label="Adicionar grupo" icon="pi pi-plus" class="p-button-text p-button-sm"
            [disabled]="isDisabled" (click)="addGroup()"></button>
    </div>
</div>
